import { Injectable } from "@angular/core";
import { EMPTY, Observable } from "rxjs";
import { RequestUtilsService } from "./requestUtils";
import { mapUserContacts, mapAccount, mapAccounts } from "./requestMapperUtils";
import { GetHttpHeadersSimple } from "./serviceUtils";
import type { Account } from "../interfaces/accounts.interface";
import type { UserContact } from "../interfaces/user-info.interface";

@Injectable({
    providedIn: "root"
})
export class AccountsService {
    constructor(private requestUtils: RequestUtilsService) {}

    getContactPerson(userEmail: string | null, id?: string | null): Observable<UserContact[]> {
        if (!userEmail) return EMPTY;
        const url = `contacts?$select=contactid,emailaddress1,emailaddress2,emailaddress3,fullname,firstname,lastname,svk_title,svk_contactgroup,mobilephone,telephone3,preferredcontactmethodcode,statuscode,statecode,svk_webaccess,svk_smsnotificationnumber&$expand=parentcustomerid_account($select=accountnumber,name)&$filter=(emailaddress1 eq '${userEmail}' ${id ? "and contactid eq " + id : ""} and statecode eq 0 and statuscode eq 1)`;
        return this.requestUtils.createGetRequest<UserContact[]>(url, mapUserContacts);
    }

    getConnectedContactPersons(accountId: string | null): Observable<UserContact[]> {
        if (!accountId) return EMPTY;
        const url = `contacts?$select=contactid,emailaddress1,emailaddress2,emailaddress3,fullname,firstname,lastname,svk_title,svk_contactgroup,mobilephone,telephone3,preferredcontactmethodcode,statuscode,statecode,svk_smsnotificationnumber&$expand=parentcustomerid_account($select=accountnumber,name)&$filter=(statecode eq 0 and statuscode eq 1 and _parentcustomerid_value eq ${accountId})`;
        return this.requestUtils.createGetRequest<UserContact[]>(url, mapUserContacts);
    }

    updateContactPerson(contactId: string | undefined, contactInformation: Partial<UserContact>): Observable<Partial<UserContact>> {
        if (!contactId) return EMPTY;
        const url = `contacts(${contactId})`;
        return this.requestUtils.createPatchRequest<Partial<UserContact>>(url, contactInformation, (response) => response);
    }

    getAccount(accountId: string): Observable<Account> {
        if (!accountId) return EMPTY;
        const url = `accounts(${accountId})?$select=name,emailaddress1,address1_composite,svk_hasaccountadmin`;
        return this.requestUtils.createGetRequest<Account>(url, mapAccount, GetHttpHeadersSimple);
    }

    getConnectedAccounts(accountId: string): Observable<Account[]> {
        if (!accountId) return EMPTY;
        const url = `accounts?$select=name,accountid&$filter=(statecode eq 0 and _parentaccountid_value eq (${accountId}))&$orderby=name asc`;
        return this.requestUtils.createGetRequest<Account[]>(url, mapAccounts, GetHttpHeadersSimple);
    }
}
